// extracted by mini-css-extract-plugin
module.exports = {"figure":"style_figure__PcnLo","caption":"style_caption__jEo8F g-type-body-small"};